import { useCallback } from "react"
import { useGetAllData } from "./useGetAllData/useGetAllData"

export const useGetFeatures = () => {
	const { data, setData, isLoading, getAllData } = useGetAllData()

	const getFeatures = useCallback(() => {
		getAllData("/api/v2/feature", (result) => result)
	}, [getAllData])

	return { data, setData, isLoading, getFeatures }
}
